import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { getCustomerConversionFollowListByCustomerConversionId } from '@/api/customer'
import ElSelectSchool from '@/components/el-select-school/index.vue'

const attendSchoolTypeList = [
    {label: '海外院校', value: '0'},
    {label: '国内院校', value: '1'},
    {label: '国际高中', value: '2'},
    {label: '普高', value: '3'},
    {label: '其他', value: '4'},
]
Vue.filter('filterAttendSchoolType', (val: string) => {
    const item = attendSchoolTypeList.filter(item => item.value === val)[0]
    return item ? item.label : ''
})
@Component({
    components: { ElSelectSchool }
})
export default class BackClue extends Vue {
    // data
    isMessageReviewId: number; //跟进记录的审批id
    operationShow = true
    tableData = []
    logData = []
    id: number;
    page = 1
    limit = 20
    total = 0
    formatDate = formatDate
    infoData: any = ''
    loading = false
    status: number;
    opinion = ''
    opinionDialog = false
    shenpiStatus = 1
    addDataList: any
    editFileList: { cnFile: string; file: string; isRequired: string }[] = []

    editFiles = {
        realName: null,
        gender: null,
        phone: null,
        email: null,
        weChat: null,
        attendSchool: null,
        grade: null,
        specialized: null,
        targetSpecialized: null,
        remark: null,
        eduTemandList: null,
        parentName: null,
        parentPhone: null,
        parentWeChat: null,
        targetSchool: null,
        achievement: null,
        feedback: null,
        overseasStudy: null,
        activeConsultation: null,
        schoolId: null
    }
    isRequired = false

    gradeList = [  // 年级列表
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业'
    ]
    eduTemandOptions = ['留学', '高考', '考研', '保研', '考博', '无升学需求']
    disBtn = false
    types = ''
// 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    isNotReject = false

    created() {
        this.status = Number(this.$route.query.status)
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.id = Number(this.$route.query.id)
        this.getData()
    }

    editFileShow(key: string) {
        if (this.status != 0) return false
        return this.editFileList.some(item => item.file === key)
    }

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    // methods
    async getData() {
        const data: any = await getMessageReviewById(this.id,this.types)
        this.infoData = data.result
        this.isNotReject = data.result.isNotReject == true ? false : true
        this.logData = data.result.messageReviewLogList
        this.editFileList = data.result.editFileList
        this.editFileList.forEach(item => {
            this.editFiles[item.file] = this.infoData[item.file]
        })
        this.editFileList.forEach(item => console.log(item.cnFile))
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.editFileList[0].isRequired === '1' ? true : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.isMessageReviewId = data.result.id
        this.$nextTick(() => {
            (this.$refs['table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {

                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
        this.stepNode.isFirstNode = this.infoData.isFirstNode
        this.stepNode.isSyncEkuaibao = this.infoData.isSyncEkuaibao
        this.stepNode.isSyncEqianbao = this.infoData.isSyncEqianbao
        this.getTableData()
    }

    // async getTableData() {
    //     const data: any = await getMessageReviewById(this.id)
    //     this.tableData = data.result.customerConversionFollowList
    //     this.total = this.tableData.length
    // }
    async getTableData() {
        this.loading = true
        await getCustomerConversionFollowListByCustomerConversionId({
            page: this.page,
            limit: this.limit,
            isMessageReview:'1',
            customerConversionId: this.isMessageReviewId
        }).then((data: any)=>{
            this.total = data.allNum
            this.tableData = data.customerConversionFollowList
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }


    // 选择学校
    changeSchool(e) {
        this.editFiles.attendSchool = e.name || ''
        this.editFiles.schoolId = e.id || undefined
    }


    confirm() {
        this.$set(this.approvedData, 'status', 1)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        this.$set(this.approvedData, 'approveId', this.id)
        this.approvedVisible = true
    }
    reject() {
        this.shenpiStatus = 2
        this.opinionDialog = true
    }

    closeDalog() {
        this.opinionDialog = false
    }

    // confirmDialog() {
    //     if (this.isRequired && this.shenpiStatus === 1) {
    //         for (let i = 0; i < this.editFileList.length; i++) {
    //             const item = this.editFileList[i]
    //             if (!this.editFiles[item.file] || this.editFiles[item.file].length === 0) {
    //                 this.$message.error('请将信息填写完整')
    //                 return
    //             }
    //         }
    //     }
    //     const newObj: any = {}
    //     this.editFileList.forEach(item => {
    //         newObj[item.file] = this.editFiles[item.file]
    //     })
    //     if('attendSchool' in newObj) {
    //         newObj['schoolId'] = this.editFiles.schoolId
    //
    //     }
    //     const obj = {
    //         messageReviewId: this.id,
    //         status: this.shenpiStatus,
    //         opinion: this.opinion,
    //         form: this.shenpiStatus === 2 ? {} : newObj,
    //         nodeType: this.nodeType,
    //     }
    //     for (const key in obj) {
    //         if (!obj[key] || obj[key].length === 0) {
    //             delete obj[key]
    //         }
    //     }
    //     this.disBtn = true
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.opinionDialog = false
    //         this.$message.success(this.shenpiStatus === 1 ? '审批通过' : '审批驳回')
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         // console.log(err)
    //         this.disBtn = false
    //     })
    // }

    // 通过
    // approvedConfirm() {
    //     if (this.isRequired && this.shenpiStatus === 1) {
    //         for (let i = 0; i < this.editFileList.length; i++) {
    //             const item = this.editFileList[i]
    //             if (!this.editFiles[item.file] || this.editFiles[item.file].length === 0) {
    //                 this.$message.error('请将信息填写完整')
    //                 return
    //             }
    //         }
    //     }
    //     const newObj: any = {}
    //     this.editFileList.forEach(item => {
    //         newObj[item.file] = this.editFiles[item.file]
    //     })
    //     if('attendSchool' in newObj) {
    //         newObj['schoolId'] = this.editFiles.schoolId
    //
    //     }
    //     const obj = {
    //         messageReviewId: this.id,
    //         status: this.shenpiStatus,
    //         opinion: this.opinion,
    //         form: this.shenpiStatus === 2 ? {} : newObj,
    //         isRevoke: this.isAgreeRevoke
    //     }
    //     for (const key in obj) {
    //         if (!obj[key] || obj[key].length === 0) {
    //             delete obj[key]
    //         }
    //     }
    //
    //     this.disBtn = true
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.opinionDialog = false
    //         this.$message.success(this.shenpiStatus === 1 ? '审批通过' : '审批驳回')
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         // console.log(err)
    //         this.disBtn = false
    //     })
    // }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.opinion = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()
        this.approvedVisible = false
    }

    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.id)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.opinion = data.reviewIdea
        // this.approvalVisible = false
        // this.confirmDialog()
        this.approvalVisible = false
    }


    /*
  * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }
}
